export const ACTION_NEW = 'New';
export const ACTION_EDIT = 'Edit';

export const TRANSACTION_TYPE_CREDIT = 'Credit';
export const TRANSACTION_TYPE_DEBIT = 'Debit';
